import React, { FC } from 'react';
import { Container } from './styles';
import { Props } from './types';

const DropdownIndicator: FC<Props> = ({ className, innerProps }) => (
  <Container className={className} {...innerProps} />
);

export default DropdownIndicator;
